export const BILL_SALE_MODE_VALUES = ['retail', 'wholesale'] as const
export type BillSaleMode = (typeof BILL_SALE_MODE_VALUES)[number]

export const BILL_SALE_MODE_LABELS_TH: Record<BillSaleMode, string> = {
  retail: 'ปลีก',
  wholesale: 'ส่ง',
}
